import Helmet from 'react-helmet';

export const StaticPageScripts = () => (
  <Helmet>
    <script src="https://platform.twitter.com/widgets.js" defer></script>
    <script src="https://ajax.googleapis.com/ajax/libs/jquery/3.2.1/jquery.min.js" defer></script>
    <script src="https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/js/bootstrap.min.js" defer></script>
  </Helmet>
);
